import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { TextLoca } from "../generic/text/TextLoca";
export var ImprovementMaxLevelReached = function () {
    return (React.createElement("div", { className: "flex flex--guts flex__full" },
        React.createElement(TextLoca, { id: IdLoca.maxLevelReached, className: IdStyles.TextNormal })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/ImprovementMaxLevelReached.tsx
// module id = 2693
// module chunks = 3